// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import React, { ReactElement } from "react";
import { Theme, ThemeProvider } from "@material-ui/core";

import Dialog from "../components/ui/Dialog";
import { confirmAlert as reactConfirmAlert } from "react-confirm-alert";

interface confirmAlertConfig {
  title?: string | ReactElement;
  message?: string | Array<string> | ReactElement;
  onClick?: () => void;
  theme?: Theme;
}

export function confirmAlert(config: confirmAlertConfig) {
  const { title, message, onClick, theme } = config;
  reactConfirmAlert({
    customUI: ({ onClose }) => {
      const onCloseCallback = () => {
        onClick && onClick();
        onClose();
      };

      const dialog = (
        <Dialog
          title={title}
          onClose={onCloseCallback}
          parentWillUnmountOnClose={true}
        >
          {message}
        </Dialog>
      );
      if (theme) {
        return <ThemeProvider theme={theme}>{dialog}</ThemeProvider>;
      }

      return dialog;
    },
  });
}
